import { GCP_HOSTING_USER_PROMPT } from '@/features/chat/demo/gcpHostingDemoContent.js'
import { runGcpHostingDemoStream } from './runGcpHostingDemoStream.js'

/**
 * The website-CRM "proceed" reply rewrites the last user message to the GCP
 * hosting prompt before replaying that demo stream.
 */
export function runWebsiteCrmProceedTurn(ctx) {
  const { tid, setMessagesByThreadId } = ctx
  setMessagesByThreadId((prev) => {
    const thread = [...(prev[tid] ?? [])]
    for (let i = thread.length - 1; i >= 0; i--) {
      const message = thread[i]
      if (message && typeof message === 'object' && message.role === 'user') {
        thread[i] = { ...message, text: GCP_HOSTING_USER_PROMPT }
        break
      }
    }
    return { ...prev, [tid]: thread }
  })
  runGcpHostingDemoStream(ctx)
}
